<app-alarm-player></app-alarm-player>
<app-global-panic-alert></app-global-panic-alert>
<app-spinner></app-spinner>
<router-outlet></router-outlet>